export default {
	unitName: "Mention",
	onConnected() {

	}
}